module.exports = __webpack_public_path__ + "img/line_1.e6a46501.png";